<template>
  <div class="jysjx" v-html="list[0].content">
    <!-- <div class="li animation srcospcur">
      <div class="tit ft24">营业收入</div>
      <div class="con">
        <img src="/static/management/20190805164149.jpg" />
      </div>
    </div>

    <div class="li animation srcospcur">
      <div class="tit ft24">公司价值</div>
      <div class="con">
        <img src="/static/management/20190805164203.jpg" />
      </div>
    </div>-->
  </div>
</template>
<script>
export default {
  props: {
    data: [Object, Array]
  },
  data() {
    return {
      list: this.$props.data || []
    };
  }
};
</script>